import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {

  constructor() { }
  //
  // showMap = false;
  // showAgenda = false;
  // showDownloads = false;
  // showSupport = false;
  // downloads = downloads;
  // url = rocketChatURL + '/channel/announcements?layout=embedded';
  // agenda = agenda;
  // support = support;
  //
  // customButton = customToolbarButton;
  // customButtonText = customToolbarButtonText;
  // customButtonLink = customToolbarButtonLink;
  //
  ngOnInit(): void {
  }
  //
  // onClick(container: string) {
  //   if (container === 'map') {
  //     this.showMap = !this.showMap;
  //     this.showSupport = false;
  //     this.showDownloads = false;
  //     this.showAgenda = false;
  //   } else if (container === 'agenda') {
  //     this.showAgenda = !this.showAgenda;
  //     this.showSupport = false;
  //     this.showDownloads = false;
  //     this.showMap = false;
  //   } else if (container === 'downloads') {
  //     this.showDownloads = !this.showDownloads;
  //     this.showSupport = false;
  //     this.showAgenda = false;
  //     this.showMap = false;
  //   } else if (container === 'support') {
  //     this.showSupport = !this.showSupport;
  //     this.showDownloads = false;
  //     this.showAgenda = false;
  //     this.showMap = false;
  //   } else {
  //     this.showSupport = false;
  //     this.showDownloads = false;
  //     this.showAgenda = false;
  //     this.showMap = false;
  //   }
  // }
  //
  // openCustomLink() {
  //   window.open(this.customButtonLink, '_blank');
  // }

}
